import React, { useEffect } from "react";
import {
  Box,
  Breadcrumbs,
  Card,
  CardHeader,
  Container,
  makeStyles,
} from "@material-ui/core";
import { Link, useHistory, useLocation } from "react-router-dom";
import Page from "src/components/Page";
import BudgetRequisitionFormComponent from "src/components/forms/BudgetRequisitionFormComponent";
import { useSelector, useDispatch } from "react-redux";
import { getDepts } from "src/redux/actions/department.action";
import {
  createBudgetAdj,
  getBudgetAdjProject,
  getBudgetAdjTo,
} from "src/redux/actions/budgetAdjustment.action";
import { getBuHead } from "src/redux/actions/getbuhead.action";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

export default function CreateBudgetRequisitionComponent() {
  const classes = useStyles();

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const departmentReducer = useSelector((state) => state.departmentReducer);

  const { projects, budgets } = useSelector(
    (state) => state.budgetAdjustmentReducer
  );
  const getbuheadReducer = useSelector((state) => state.getbuheadReducer);
  const {
    result: {
      perid,
      fullname,
      email,
      brand_id,
      brand,
      department_id,
      department,
      currencyid,
      country_code,
      currency_code,
      secureid,
    },
  } = useSelector((state) => state.loginReducer);

  useEffect(() => {
    dispatch(getBuHead(perid));
    dispatch(
      getDepts(
        location.state.BUDGETS_COUNTRY,
        location.state.BUDGETS_COMPANY,
        secureid,
        location.state.BUDGETS_BRAND
      )
    );
    dispatch(
      getBudgetAdjProject(
        location.state.BUDGETS_COUNTRY,
        location.state.BUDGETS_COMPANY,
        location.state.BUDGETS_BRAND,
        location.state.BUDGETH_YEARCODE,
        location.state.BUDGETS_DEPARTMENT
      )
    );
    dispatch(getBudgetAdjTo(location.state.ACC_CODE, 0));
    return () => {};
  }, []);

  return (
    <Page
      className={classes.root}
      title="Budget Requisition Form - Create Investment Budget Transfer"
    >
      <Container maxWidth={false}>
        <Box mb={2}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              color="inherit"
              onClick={() => {
                history.replace("/budget-adjustment-requisition");
              }}
            >
              Budget Adjustment
            </Link>
            <Link
              color="inherit"
              onClick={(e) => {
                history.replace("/budget-code-selection");
              }}
            >
              Budget Selection
            </Link>
            <Link color="textPrimary" aria-current="page">
              Budget Requisition Form
            </Link>
          </Breadcrumbs>
        </Box>
        <Box mb={2}>
          <Card>
            <CardHeader
              subheader="For budget adjustment on the system."
              title="Budget Requisition Form - Create Investment Budget Transfer"
            />
          </Card>
        </Box>
        <Box mb={2}>
          <BudgetRequisitionFormComponent
            formType={"CREATE"}
            departmentTo={departmentReducer.result}
            projectsTo={projects.data}
            budgetsTo={budgets.data}
            ReasonLog={[]}
            formValue={{
              BUDGET_YEAR: location.state.BUDGETH_YEARCODE,
              STATUS: 0,
              STATUS_DESC: "PREPARE",
              BUDGET_TYPE: location.state.ACC_CATEGORY, // 1 = Investment , 0 = Expense
              COUNTRY_CODE: country_code,
              BRAND_CODE: location.state.BRAND_CODE,
              BUDGET_TYPE_DESC:
                location.state.ACC_CATEGORY === 1
                  ? "Investment"
                  : location.state.ACC_CATEGORY === 0
                  ? "Expense"
                  : "",
              ADJ_TYPE: 1,
              REQUESTED_BY_ID: perid,
              REQUESTED_BY_NAME: fullname,
              REQUESTED_BY_EMAIL: email,
              REQUESTED_BRAND: brand_id,
              REQUESTED_DEPARTMENT: department_id,
              REQUESTED_BRAND_NAME: brand,
              REQUESTED_DEPARTMENT_NAME: department,
              REVIEWED_BY_ID: null,
              REVIEWED_BY_NAME: "",
              REVIEWED_BY_EMAIL: "",
              CURRENCY_ID: currencyid,
              CURRENCY_CODE: currency_code,
              COUNTRY_ID: location.state.BUDGETS_COUNTRY,
              COUNTRY_NAME: location.state.COUNTRY_NAME,
              COMPANY_ID: location.state.BUDGETS_COMPANY,
              COMPANY_NAME: location.state.COMPANY_NAME,
              BRAND_NAME: location.state.BRAND_NAME,
              BRAND_ID: location.state.BUDGETS_BRAND,
              DEPARTMENT_ID: location.state.BUDGETS_DEPARTMENT,
              DEPARTMENT_NAME: location.state.DEPARTMENT_NAME,
              F_PROJECT_CODE:
                location.state.BUDGETP_CODE != 0
                  ? location.state.BUDGETP_CODE
                  : null,
              F_PROJECT_NAME: location.state.BUDGETP_NAME,
              F_BUDGET_CODE: location.state.ACC_CODE,
              F_BUDGET_NAME: location.state.ACC_NAME,
              F_BRAND: location.state.BUDGETS_BRAND,
              F_BRAND_NAME: location.state.BRAND_NAME,
              F_DEPARTMENT: location.state.BUDGETS_DEPARTMENT,
              F_DEPARTMENT_NAME: location.state.DEPARTMENT_NAME,
              F_BUDGET_REMAIN: parseFloat(location.state.REMAINING).toFixed(2),
              T_PROJECT_CODE: null,
              T_PROJECT_NAME: null,
              T_BUDGET_CODE: null,
              T_BUDGET_NAME: null,
              T_BRAND: location.state.BUDGETS_BRAND,
              T_DEPARTMENT: location.state.BUDGETS_DEPARTMENT,
              T_BUDGET_REMAIN: null,
              AMOUNT: null,
              REASON_ADJUSTMENT: null,
              REASON: "",
            }}
            onSubmit={(value) => {
              const [approval] = getbuheadReducer.result;
              if (approval) {
                value.STATUS = 1; //PREPARE
                value.REVIEWED_BY_ID = approval.PER_ID;
                value.REVIEWED_BY_NAME = approval.FULLNAME;
                value.REVIEWED_BY_EMAIL = approval.PER_EMAIL;
                dispatch(createBudgetAdj(value, history));
              } else {
                Swal.fire(
                  "The system message.",
                  "Your reviewer has not found!",
                  "warning"
                );
              }
            }}
          />
        </Box>
      </Container>
    </Page>
  );
}
